import { HttpClient, HttpContext } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { SKIP_INTERCEPTOR } from 'app/shared/interceptors/auth.interceptor';

/**
 * Translation loader that fetches `assets/i18n/<lang>.json` while bypassing
 * the auth interceptor — translation files are static assets that do not
 * require Cognito tokens (and must be loadable before sign-in).
 */
export class TranslateAssetLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  public getTranslation(lang: string): Observable<TranslationObject> {
    const context = new HttpContext().set(SKIP_INTERCEPTOR, true);
    return this.http.get<TranslationObject>(`./assets/i18n/${lang}.json`, { context });
  }
}
